import React from 'react';
import { imgV2 as img } from '@styles/utils';

import styles from './badges-list.styles';
import { IProduct } from '@v2/interfaces';

const IconCLPA = 'pdp2/claim-badges/CLPA.svg';
const IconNonBPA = 'pdp2/claim-badges/NonBPA.svg';
const IconVegan = 'pdp2/claim-badges/Vegan.svg';
const IconGUSDA = 'pdp2/claim-badges/USDA.svg';
const IconNonGMO = 'pdp2/claim-badges/NonGMO.svg';

interface IBadgeConfig {
    icon: string,
    title?: string,
    description?: string,
    excludeFor?: Array<String>,
    hide?: boolean
}

export function BadgesList({ bundle, productBadgeType = 'none', productTitle }: { bundle?: IProduct, productBadgeType?: string, productTitle: string }) {
    const hideNonGMO = !['gluten-free'].includes(productBadgeType);
    const hideVegan = bundle ? bundle.products.some((product) => {
        return [
            'Sweet Potato Pinto Bean',
            'Butternut Squash Chicken Broth',
            'Carrot Beef Broth',
            'Sweet Potato Chicken Broth',
        ].includes(product.title)
    }) : [
        'Sweet Potato Pinto Bean',
        'Butternut Squash Chicken Broth',
        'Carrot Beef Broth',
        'Sweet Potato Chicken Broth',
    ].includes(productTitle);

    const badges: IBadgeConfig[] = [
        {
            icon: IconCLPA,
            excludeFor: null,
            title: null,
        },
        {
            icon: IconNonBPA,
            excludeFor: null,
            title: null,
        },
        {
            icon: IconVegan,
            title: null,
            hide: hideVegan
        },
        {
            icon: IconGUSDA,
            excludeFor: null,
            title: null,
        },
        {
            icon: IconNonGMO,
            hide: hideNonGMO,
        },
    ];

    return (
        <span className={styles.container}>
            {
                Object.values(badges).map((badge, index) => !badge.hide ?
                    <div className="ing-circle" key={index}>
                        <img loading="lazy" src={img(badge.icon)} alt={badge.title} />
                    </div> : null
                )
            }
        </span>
    );
}